import React from 'react';
import nkyLogo from '../../../assets/images/logoNoWords.png';
import FractionalStarRating from '../FractionalStarRating/FractionalStarRating';
import { RatingLine, RatingMeta, BrandLogo } from './CompactBusinessRatingLine.styled';

const GOOGLE_LOGO_URL =
  'https://www.gstatic.com/images/branding/googlelogo/svg/googlelogo_clr_74x24px.svg';

/**
 * Single-line rating: stars · score · review count · brand logo (NKY or Google).
 */
export default function CompactBusinessRatingLine({
  source,
  rating,
  reviewCount,
  surface = 'light',
  onClick,
  as = 'div',
}) {
  const numericRating = Number(rating);
  const count = Number(reviewCount);
  if (Number.isNaN(numericRating) || count <= 0) {
    return null;
  }

  const filledColor = source === 'google' ? '#fbbc04' : '#01ebb2';
  const emptyColor = '#d4d8e0';
  const brandLogo = source === 'google' ? GOOGLE_LOGO_URL : nkyLogo;
  const brandAlt = source === 'google' ? 'Google' : 'NKY Connect';
  const labelSource = source === 'google' ? 'Google' : 'NKY Connect';
  const interactive = Boolean(onClick);
  const ariaLabel = `${labelSource} rating ${numericRating.toFixed(1)} from ${count.toLocaleString()} reviews`;

  const content = (
    <>
      <FractionalStarRating
        rating={numericRating}
        filledColor={filledColor}
        emptyColor={emptyColor}
        iconSize="14px"
      />
      <RatingMeta $surface={surface}>
        {numericRating.toFixed(1)} · {count.toLocaleString()} review
        {count === 1 ? '' : 's'}
      </RatingMeta>
      <BrandLogo src={brandLogo} alt={brandAlt} $source={source} />
    </>
  );

  if (as === 'button') {
    return (
      <RatingLine
        as="button"
        type="button"
        onClick={onClick}
        $surface={surface}
        $interactive={interactive}
        aria-label={ariaLabel}
      >
        {content}
      </RatingLine>
    );
  }

  return (
    <RatingLine $surface={surface} $interactive={false} aria-label={ariaLabel}>
      {content}
    </RatingLine>
  );
}
